module.exports = __webpack_public_path__ + "img/18_42.f28f1bc6.png";